export default "__VITE_ASSET__DXw1juWr__"